// extracted by mini-css-extract-plugin
export default {"results":"styles_results__sm6ZA"};